import n26Logo from '@assets/images/logo-112x112.png'

export function createStructuredDataForLogo(websiteUrl: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    url: websiteUrl,
    logo: `${websiteUrl}${n26Logo}`,
  }
}
